import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import buildStylesAndClasses from './buildStyles'

function SingleCaption({ caption, stylesAndClasses }) {
  const {
    captionWindowElementProps,
    captionBackgroundElementProps,
    captionTextElementProps,
  } = stylesAndClasses
  return (
    <div className="caption-wrapper">
      <div {...captionWindowElementProps}>
        <div {...captionBackgroundElementProps}>
          <div
            {...captionTextElementProps}
            dangerouslySetInnerHTML={{ __html: caption.text }}
          />
        </div>
      </div>
    </div>
  )
}

SingleCaption.propTypes = {
  caption: PropTypes.shape({
    text: PropTypes.string,
  }),
  stylesAndClasses: PropTypes.shape({
    captionWindowElementProps: PropTypes.object,
    captionBackgroundElementProps: PropTypes.object,
    captionTextElementProps: PropTypes.object,
  }),
}

function renderCaptions(captions, stylesAndClasses) {
  return captions.map((caption) => (
    <SingleCaption
      key={caption.id}
      caption={caption}
      stylesAndClasses={stylesAndClasses}
    />
  ))
}

function Captions({ captions = [], captionStyles = {} }) {
  const stylesAndClasses = useMemo(
    () => buildStylesAndClasses(captionStyles),
    [captionStyles]
  )

  const captionsRendered = useMemo(
    () => renderCaptions(captions, stylesAndClasses),
    [captions, stylesAndClasses]
  )
  return (
    <div className="captions-container" data-testid="captions">
      {captionsRendered}
    </div>
  )
}

Captions.propTypes = {
  captions: PropTypes.array,
  captionStyles: PropTypes.object,
  getNextCues: PropTypes.func,
}
export default Captions
